import React from 'react'
import loadable from '@loadable/component'

import HeaderMeta from 'components/HeaderMeta'

import PageHero, { Theme as PageHeroTheme } from 'components/blocks/PageHero'
import GroupQuoteForm from 'components/blocks/GroupQuoteForm'
import AskQuestion from 'components/blocks/AskQuestion'
import SectionRule from 'components/base/SectionRule/styles'
import Content from 'components/base/Content'
import { Level as TitleLevel } from 'components/base/Title'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'
import Img from 'components/base/Img'

import UnitedLogo from '../assets/united-logo.png'

const Title = loadable(() => import('components/base/Title').catch(() => () => null))

const GroupInsuranceQuoteScreen: React.FC = (): React.ReactElement => {
  return (
    <div>
      <HeaderMeta
        title='Product Group Quote | Insurance Lounge'
        description='Get a group quote from insurance lounge.'
        noIndex={true}
      />
      <PageHero theme={PageHeroTheme.groupQuote} />
      <Content center={true} margined={true}>
        <Img
          src={UnitedLogo}
          src2x={undefined}
          style={{
            maxHeight: '110px',
            width: '100%',
            maxWidth: '350px',
          }}
          alt='United Insurance'
        />
        <Content center={true} short={true} margined={true}>
          <Title margin={true} level={TitleLevel.pageLarge}>A UnitedHealthcare plan built for up to 34%* lower costs.</Title>
        </Content>
        <Paragraph theme={ParagraphTheme.ctaBoldBlue}>Get started at Insurance Lounge.</Paragraph>
      </Content>
      <SectionRule />
      <GroupQuoteForm />
      <SectionRule />
      <AskQuestion title='We’re Here, When You Need Us'>
        Online, over the phone, or in person, we always have one of our no commission Insurance
        Concierges<sup>®</sup> ready to help.
      </AskQuestion>
      <SectionRule />
      <Content center={true} margined={true} short={true}>
        <Paragraph theme={ParagraphTheme.small}>* Up to 34% lower costs based on 2022 UnitedHealthcare internal analysis between UnitedHealthcare Insurance Company and Level Funded medical plans with Pacific Northwest (OR/WA/MT) groups of 5–50 eligible employees. Savings are not guaranteed.</Paragraph>
        <Paragraph theme={ParagraphTheme.small}>24/7 Virtual Visits is a service available with a Designated Virtual Network Provider via video, or audio-only where permitted under state law. Unless otherwise required, benefits are available only when services are delivered through a Designated Virtual Network Provider. 24/7 Virtual Visits are not intended to address emergency or life-threatening medical conditions and should not be used in those circumstances. Services may not be available at all times, or in all locations, or for all members. Check your benefit plan to determine if these services are available.</Paragraph>
        <Paragraph theme={ParagraphTheme.small}>Administrative services provided by United HealthCare Services, Inc. or their affiliates, and UnitedHealthcare Service LLC in NY. Stop-loss insurance is underwritten by UnitedHealthcare Insurance Company or their affiliates, including UnitedHealthcare Life Insurance Company in NJ, and UnitedHealthcare Insurance Company of New York in NY.</Paragraph>
        <Paragraph theme={ParagraphTheme.small}>This broker agency is an independent agency.<br />23-2209439</Paragraph>
      </Content>
    </div>
  )
}

export default GroupInsuranceQuoteScreen
